// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SILz","importantInfo":"styles_importantInfo__M3Wi4"};